export default {
  auth: state => state.auth,
  checked: state => state.checked,
  pending: state => state.pending,
}